import { render, staticRenderFns } from "./V2WishlistPreviewSettingsModal.vue?vue&type=template&id=61017cb6&scoped=true&"
import script from "./V2WishlistPreviewSettingsModal.vue?vue&type=script&lang=js&"
export * from "./V2WishlistPreviewSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./V2WishlistPreviewSettingsModal.vue?vue&type=style&index=0&id=61017cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61017cb6",
  null
  
)

export default component.exports